import { Modal } from "../Modal";

const LABELS = {
  task: {
    title: "Задача не найдена",
    text: "Возможно, она была удалена или у вас нет к ней доступа.",
  },
  project: {
    title: "Проект не найден",
    text: "Возможно, он был удалён или у вас нет к нему доступа.",
  },
};

const DEFAULT_LABEL = {
  title: "Объект не найден",
  text: "Возможно, он был удалён или у вас нет к нему доступа.",
};

export function EntityNotFoundModal({ entityType, onClose }) {
  const label = LABELS[entityType] || DEFAULT_LABEL;

  return (
    <Modal
      title={label.title}
      onClose={onClose}
      width={400}
      titleId="entity-not-found-title"
      trapFocus
    >
      <p className="mut">{label.text}</p>
      <div className="flex justify-end mt-4">
        <button className="btn primary" onClick={onClose}>
          Понятно
        </button>
      </div>
    </Modal>
  );
}
